import { useEffect, useState,useContext } from "react";
import { SupplierData } from "./SupplierTable";
import styles from "./Suppliers.module.css"
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from "../../Auth";
import { useNavigate } from "react-router-dom";

export default function Suppliers() {

    const [suppliers, setSuppliers] = useState<SupplierData[]>();
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    const navigate = useNavigate();
 
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                    setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                    return navigate("/login");
                }
                 const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
            } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    }, [navigate, setAuth]);

    useEffect(() => {
        const fetchSupplier = async () => {
            const response = await fetch(`${baseUrl}/getsupplier`,{
                method: "GET",
                credentials: "include",
            })
            const data = await response.json();
            setSuppliers(data);
        }

        fetchSupplier();
    }, [])

    return (
        <div className={styles.div}>
            <h2>発注先リスト</h2>
            <div className={styles.scroll}>
                <table className={styles.table}>
                    <thead><tr><th className={styles.th}>発注先</th><th className={styles.th}>メールアドレス</th><th className={styles.th}>送料無料適用額</th></tr></thead>
                    <tbody>
                        {suppliers && suppliers.map((item, index) => (<tr key={index} className={styles.tr}><td className={styles.td}>{item.supplier}</td><td className={styles.td}>{item.email}</td><td className={styles.td}>{item.freeshipping}</td></tr>))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

